import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconAntenna({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g
				fill="none"
				fillRule="evenodd"
				transform="translate(2.782 .428)scale(.107)"
			>
				<circle cx={87.5} cy={53.5} r={14.5} stroke="#FFF" strokeWidth={8} />
				<path
					stroke="#FFF"
					strokeLinecap="round"
					strokeWidth={8}
					d="M87.5 68 40.304 217.149M64 151l46-21m-42 1 46 21m-67 49 73-29m-64 0 73 29M90.5 68l47.196 149.149"
				/>
				<g stroke="#E42822" strokeLinecap="round" strokeWidth={9.4}>
					<path d="M53.028 78.666A34.37 34.37 0 0 1 43 54.343c0-4.752.955-9.279 2.691-13.392a34.3 34.3 0 0 1 7.337-10.935m-29.713 82.299a79.15 79.15 0 0 1-16.84-25.087C2.498 77.784.297 67.403.297 56.508c0-10.898 2.2-21.278 6.177-30.723A79 79 0 0 1 23.315.702" />
					<path d="M38.608 95.447A57.2 57.2 0 0 1 26.454 77.34C23.582 70.524 22 63.026 22 55.165c0-7.869 1.582-15.36 4.454-22.179a57 57 0 0 1 12.154-18.102" />
				</g>
				<g stroke="#E42822" strokeLinecap="round" strokeWidth={9.4}>
					<path d="M120.972 78.666A34.37 34.37 0 0 0 131 54.343c0-4.752-.955-9.279-2.691-13.392a34.3 34.3 0 0 0-7.337-10.935m29.713 82.299a79.15 79.15 0 0 0 16.84-25.087c3.976-9.444 6.176-19.825 6.176-30.72 0-10.898-2.2-21.278-6.176-30.723A79 79 0 0 0 150.685.702" />
					<path d="M135.392 95.447a57.2 57.2 0 0 0 12.154-18.107C150.418 70.524 152 63.026 152 55.165c0-7.869-1.582-15.36-4.454-22.179a57 57 0 0 0-12.154-18.102" />
				</g>
			</g>
		</svg>
	);
}
